import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const imageStyle = css`
  width: 48rem;
  height: 36rem;
  @media ${BREAKPOINT_QUERIES.Mobile} {
    width: 100%;
    height: 24rem;
  }
`;

export const mobileImageStyle = css`
  width: 100%;
  height: 24rem;
`;
